import { resolveComputedCssValues } from '@utils/css';
import { appContextStore } from './app-context.state.js';

function configureIframeExport(iframeRef, headerSurfaceToken) {
  var _a;
  const iframe = "current" in iframeRef ? iframeRef.current : iframeRef;
  if (!iframe) {
    return;
  }
  const publisherSvg = resolvePublisherLogo();
  const headerSurface = resolveComputedCssValues({
    background: headerSurfaceToken.background(),
    color: headerSurfaceToken.color()
  });
  const product = appContextStore.getState().product;
  (_a = iframe.contentWindow) == null ? void 0 : _a.postMessage({
    action: "export:configure",
    productName: `
      ${publisherSvg}
      ${product !== void 0 ? `<span style="text-transform: uppercase; margin-left: 0.5em;">
              <b>${product.subject}</b>
              ${product.gradesLabel ?? ""}
              ${product.classLabel ?? ""}
            </span>` : ""}
    `,
    headerBackgroundColor: headerSurface.background,
    headerTextColor: headerSurface.color
  });
}
function resolvePublisherLogo() {
  const publisher = appContextStore.getState().publisher;
  switch (publisher) {
    case "hans-reitzel":
      return `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 283.46 283.46"
          height="1em"
          width="1em"
        >
          <path
            fill="currentColor"
            d="M176.359 171.679c-6.795 0-15.678-2.807-19.113-4.848-.168-2.074-.393-12.113-.217-25.535 0-13.994.326-23.539 1.102-30.685 35.453-3.796 50.771 4.688 50.771 25.861 0 34.41-25.549 35.207-32.543 35.207m106.209 81.944c-8.764 1.668-25.383-1.172-41.705-24.074-18.27-25.629-32.615-46.736-38.037-53.451 7.121-3.572 31.521-20.805 31.521-45.206 0-13.972-9.4-36.642-40.031-36.642-9.672 0-27.057 2.265-35.932 2.265-1.451-30.741 3.078-48.794 10.191-60.932 7.152-12.161 18.27-21.515 34.768-21.515 21.451 0 33.373 15.175 36.818 19.115 3.26 3.771 20.867-10.16 20.867-14.282 0-7.68-21.553-18.9-44.137-18.9-21.188 0-38.521 4.737-54.377 16.603-20.885 15.614-27.143 38.492-29.217 56.234-2.111 18.182-5.198 26.562-17.406 26.562h-13.054v11.491h27.511s.687 6.786.687 15.519v41.291c-20.447 1.066-62.941 1.066-81.793 0v-10.799c0-6.689-.056-17.79.741-28.245.997-13.11 2.042-20.118 15.392-22.376l-1.588-7.687c-15.334 1.339-46.498.805-62.199 0L0 106.537c15.908 1.842 22.472 3.621 22.472 25.104v62.805c0 13.357-.048 25.088-.798 35.414-1.362 19.035-6.061 21.389-16.952 22.191l1.595 7.799c17.512-1.594 45.836-1.307 62.264 0l1.65-7.926c-16.188-1.777-20.988-4.074-20.988-24.641v-44.529c18.58-1.012 62.279-.877 81.793 0v13.021c0 10.336-.023 23.652-.902 34.082-1.506 17.584-5.414 21.014-16.545 22.328l1.722 7.664c17.353-1.596 46.075-1.309 63.021 0l1.596-8.062c-15.414-1.115-21.906-3.453-22.336-23.572-.279-13.619-.439-38.658-.057-45.812 4.648.877 13.971 1.469 20.758 1.174 5.295 7.08 23.213 36.555 31.418 49.01 18.334 27.871 35.215 37.072 73.738 28.668.164.022-.881-7.632-.881-7.632"
          />
        </svg>
      `;
    case "munksgaard":
      return `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 283.46 283.46"
          height="1em"
          width="1em"
          fill="currentColor"
        >
          <path d="M141.732 192.412C79.46 141.274 28.109 123.458 28.109 123.458L0 152.753c100.547 45.314 141.732 93.924 141.732 93.924h.01s41.186-48.609 141.723-93.924l-28.109-29.295s-51.342 17.815-113.613 68.955h-.01v-.001z" />
          <path d="M204.794 64.335c0 35.547-28.279 64.353-63.172 64.353-34.895 0-63.172-28.806-63.172-64.353C78.451 28.822 106.728 0 141.623 0c34.892 0 63.171 28.822 63.171 64.335z" />
        </svg>
      `;
    default:
      return `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 52.9 79.6"
          height="1em"
          width="0.6737em"
          fill="currentColor"
        >
          <path d="M26.4 79.5c12.3 0 17.5-1.9 21.4-8 3.6-5.8 5.2-13.2 5.2-31.8s-1.6-26-5.2-31.8c-3.9-6-9-7.9-21.3-7.9h.2C14.2 0 9.1 1.9 5.2 7.9 1.6 13.8 0 21.2 0 39.8s1.6 26 5.2 31.8c3.9 6 9 8 21.3 8zm.2-2.2c-10.7 0-15.4-1.2-18.5-6.5s-3.7-13-3.7-31 .5-25.8 3.7-31 7.8-6.4 18.5-6.4h-.2c10.7 0 15.4 1.2 18.5 6.4s3.7 13 3.7 31.1c0 18-.5 25.8-3.7 31.1s-7.8 6.5-18.5 6.5z" />
          <path d="M15.4 52.8c-1 .1-1.7.9-1.6 1.9.1.9.8 1.6 1.6 1.6 1 .1 1.8-.7 1.9-1.6.1-1-.7-1.8-1.6-1.9h-.3zM26.2 12.7c0-.5-.4-.9-.9-.9s-1 .4-1.1.9c0 .6.4 1.1 1 1.1.6-.1 1-.6 1-1.1z" />
          <path d="M29.6 33.6c-3.5-1.8-4.3-3.6-4.3-5.9 0-5.1 5-9.2 5-13.5 0-2.8-2-4.7-5.2-4.7-.7 0-1.5.2-2.1.6-1.8-.4-7.5-1.5-8.6-1.7 0-.1-.1.1 0 .1.4.2 6.9 3.2 8.1 4.3.1.1.5.6.6.6s.2-.1.2-.4c-.1-.2-.1-.4-.1-.6.1-1.1 1-1.8 2.1-1.8h.1c1.9-.1 3.5 1.4 3.6 3.3v.1c0 1.9-1.4 4.1-1.9 4.1-.1 0-.2-.1-.2-.1 0-.5.3-1.3.3-1.9 0-.9-.3-1.9-2-1.9h-.4c-.1.1.1.1.2.1.3 0 .7.6.7 1.4 0 4.6-8.3 12.6-8.3 17.3 0 7.2 8.2 13.4 11.2 15.3.2.1.4.4.3.7 0 .1-.2.7-.5.7H16.3c-1.1 0-2.2.2-3.2.6-.8.6-1.5 1.3-2 2.2-.1 1.2.1 2.4.7 3.4.4.6 1.2.3.8-.1-.2-.5-.3-1-.3-1.5-.1-1.7 1.2-3.1 2.9-3.2s3.1 1.2 3.2 2.9v.3c0 .2.2.4.3.5.6 0 .6-.6.6-.9 0-.8-.6-1.6-.6-2.2 0-.4.2-.6 1.1-.6 2.3 0 9.1 1.1 9.8 1.1s1.3-2 1.9-2 2.6 6.5 2.6 7.3v1.1c0 .7.4 1.2.1 1.9-2.9 7.4-3.4 9.2-3.4 9.2-.6 1.4-6.5 1.5-7.9 1.5-.9 0-1.5.6-1.5.9s0 .4.2.4c3-.5 6.1-.7 9.2-.6 1 .1 2 .2 3 .5.1 0 .2-.2.2-.3 0-.7-2.7-.8-2.2-2 0 0 .4-.6 4.1-9.4.3-.6.4-1.2.5-1.8-.2-.9-.5-1.7-.8-2.6-.3-1.4-.6-2.8-.7-4.2h.2c1.3 0 2.7 2.8 2.9 3.9.2.8 1.1.8 1.8 1v1.2c0 .5.8.6 1.3.6s.6-3.2.6-3.6c-.1-8.4-4.4-17.7-12.1-21.6z" />
        </svg>
      `;
  }
}

export { configureIframeExport };
//# sourceMappingURL=util.configure-iframe-export.js.map
